/**
 * Support Reducer
 * NgRx reducer for support tickets state management
 */
import { createReducer, on } from '@ngrx/store';
import { SupportState, initialSupportState } from '../models/support.models';
import * as SupportActions from './support.actions';

export const supportReducer = createReducer(
  initialSupportState,

  // Load Stats
  on(SupportActions.loadStats, (state) => ({ ...state, loading: true, error: null })),
  on(SupportActions.loadStatsSuccess, (state, { stats }) => ({ ...state, stats, loading: false })),
  on(SupportActions.loadStatsFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Load Tickets
  on(SupportActions.loadTickets, (state) => ({ ...state, loading: true, error: null })),
  on(SupportActions.loadTicketsSuccess, (state, { tickets, total }) => ({
    ...state,
    tickets,
    totalTickets: total,
    loading: false
  })),
  on(SupportActions.loadTicketsFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Load Single Ticket
  on(SupportActions.loadTicket, (state) => ({ ...state, loading: true, error: null })),
  on(SupportActions.loadTicketSuccess, (state, { ticket }) => ({
    ...state,
    selectedTicket: ticket,
    loading: false
  })),
  on(SupportActions.loadTicketFailure, (state, { error }) => ({ ...state, loading: false, error })),

  // Create Ticket
  on(SupportActions.createTicket, (state) => ({ ...state, submitting: true, error: null })),
  on(SupportActions.createTicketSuccess, (state, { ticket }) => ({
    ...state,
    tickets: [ticket, ...state.tickets],
    submitting: false,
    successMessage: `Ticket ${ticket.ticketId} created successfully!`
  })),
  on(SupportActions.createTicketFailure, (state, { error }) => ({ ...state, submitting: false, error })),

  // Add Message
  on(SupportActions.addMessage, (state) => ({ ...state, submitting: true, error: null })),
  on(SupportActions.addMessageSuccess, (state, { message }) => ({
    ...state,
    selectedTicket: state.selectedTicket ? {
      ...state.selectedTicket,
      messages: [...(state.selectedTicket.messages || []), message]
    } : null,
    submitting: false
  })),
  on(SupportActions.addMessageFailure, (state, { error }) => ({ ...state, submitting: false, error })),

  // Close/Reopen Ticket
  on(SupportActions.closeTicket, SupportActions.reopenTicket, (state) => ({ ...state, loading: true })),
  on(SupportActions.closeTicketSuccess, SupportActions.reopenTicketSuccess, (state, { ticket }) => ({
    ...state,
    selectedTicket: ticket,
    tickets: state.tickets.map(t => t.id === ticket.id ? ticket : t),
    loading: false
  })),
  on(SupportActions.closeTicketFailure, SupportActions.reopenTicketFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Filters and Pagination
  on(SupportActions.updateFilters, (state, { filters }) => ({
    ...state,
    filters: { ...state.filters, ...filters },
    currentPage: 1
  })),
  on(SupportActions.changePage, (state, { page }) => ({ ...state, currentPage: page })),
  on(SupportActions.changePageSize, (state, { pageSize }) => ({ ...state, pageSize, currentPage: 1 })),

  // Clear
  on(SupportActions.clearSelectedTicket, (state) => ({ ...state, selectedTicket: null })),
  on(SupportActions.clearError, (state) => ({ ...state, error: null })),
  on(SupportActions.clearSuccessMessage, (state) => ({ ...state, successMessage: null }))
);

